<template>
    <el-form :model="value" ref="formRef" label-position="top">
        <Panel title="连接池配置">
            <el-row>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="服务器IP地址" prop='host'>
                        <el-input v-model="value.host"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="端口号" prop='port'>
                        <el-input v-model="value.port"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
    </el-form>
</template>
<script>
export default {
    props: {
        // host: "",
        // port: ""
        value: Object,
    },
    data() {
        return {
            rules: {
                host: [{required: true, trigger: "blur", message: "这是必填字段"}],
                port: [{required: true, trigger: "blur", message: "这是必填字段"}]
            }
        };
    },
    methods: {
        validate() {
            return this.$refs.formRef.validate();
        }
    }
};
</script>

